
import * as angular from "angular";
import * as $ from "jquery";

import "./scrollShadow.scss";
import { ThrottleService } from "@services/throttle.service";

export class ScrollShadowDirective implements angular.IDirective {

    restrict = "A";

    link: (scope: angular.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;

    constructor(
        private readonly $timeout: angular.ITimeoutService,
        private readonly $throttle: any) {

        var isIE11 = !!window["MSInputMethodContext"] && !!document["documentMode"];

        ScrollShadowDirective.prototype.link = ($scope: angular.IScope, $element: angular.IAugmentedJQuery, attrs: ng.IAttributes) => {
            if (isIE11) {
                return;
            }

            $timeout(() => {
                this.setup($scope, $element, attrs);
            }, /*2500*/500);
        }
    }

    private setup($scope: angular.IScope, $element: angular.IAugmentedJQuery, attrs: ng.IAttributes) {

        var topShadowElement: JQuery = null;
        var bottomShadowElement: JQuery = null;

        var scrollingElement = $element.find("> .md-virtual-repeat-scroller");

        if (scrollingElement.length === 0) {
            scrollingElement = $element;
        }

        var el = scrollingElement[0];
        var clientHeight = el.clientHeight;

        const scrollShadowBoth = attrs["scrollShadow"] === "both";
        var scrollShadowBottom = scrollShadowBoth || attrs["scrollShadow"] === "bottom";

        var throttle = this.$throttle(() => {

            window.performance.mark("scrollShadow");
            var scrollTop = el.scrollTop;
            var scrollHeight = el.scrollHeight;

            var scrollBuffer = 5;

            // Top Shadow
            if (scrollTop > scrollBuffer) {

                if (!topShadowElement) {
                    topShadowElement = this.addShadow(scrollingElement, "radialShadowTop", false);
                }
            }
            else if (topShadowElement) {
                topShadowElement.remove();
                topShadowElement = null;
            }

            // Bottom Shadow
            if (scrollShadowBottom) {
                if (scrollTop + clientHeight + scrollBuffer < scrollHeight) {
                    if (!bottomShadowElement) {
                        bottomShadowElement = this.addShadow(scrollingElement, "radialShadowBottom", true);
                    }
                }
                else if (bottomShadowElement) {
                    bottomShadowElement.remove();
                    bottomShadowElement = null;
                }
            }

            window.performance.measure("scrollShadow");
        }, 25);

        scrollingElement.on("scroll", (eventObject: JQueryEventObject, args: any[]) => {
            throttle();
        });

        $scope.$on("$destroy", () => {
            scrollingElement.off("scroll");
        });

        $element.trigger("scroll");
    }

    private getStyle(oElm: any, strCssRule: any) {
        var strValue = "";

        if (document.defaultView && document.defaultView.getComputedStyle) {
            strValue = document.defaultView.getComputedStyle(oElm, "").getPropertyValue(strCssRule);
        }
        else if (oElm.currentStyle) {
            strCssRule = strCssRule.replace(/\-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });

            strValue = oElm.currentStyle[strCssRule];
        }

        return strValue;
    }

    private addShadow(parentElement: JQuery, className: string, append: boolean): JQuery {
        var shadowString = `<div class="shadow ${className}"></div>`;

        var parentElementPropString = "";
        var targetElementProperty = "";
        if (append) {
            parentElement.append(shadowString);

            parentElementPropString = "padding-top";
            targetElementProperty = "bottom";
        }
        else {
            parentElement.prepend(shadowString);

            parentElementPropString = "padding-bottom";
            targetElementProperty = "top";
        }

        var shadow = parentElement.children(`.${className}`).eq(0);

        return shadow;
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($timeout: angular.ITimeoutService, $throttle: any) => new ScrollShadowDirective($timeout, $throttle);

        directive.$inject = ["$timeout", "$throttle"];

        return directive;
    }
}
